import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';

import { ClaimTypeRoutingModule } from './claim-type-routing.module';
import { ClaimTypeDetailsComponent } from './claim-type-details/claim-type-details.component';
import { ClaimTypeCreateComponent } from './claim-type-create/claim-type-create.component';
import { ClaimTypeEditComponent } from './claim-type-edit/claim-type-edit.component';
import { ClaimTypeFormContentComponent } from './shared/claim-type-form-content/claim-type-form-content.component';
import { SelectClaimTypeDocumentTypeEditContentComponent } from './shared/select-claim-type-document-type-edit-content/select-claim-type-document-type-edit-content.component';

@NgModule({
  declarations: [
    ClaimTypeDetailsComponent,
    ClaimTypeCreateComponent,
    ClaimTypeEditComponent,
    ClaimTypeFormContentComponent,
    SelectClaimTypeDocumentTypeEditContentComponent,
  ],
  imports: [CommonModule, ClaimTypeRoutingModule, SharedModule],
})
export class ClaimTypeModule {}
